const deCH= {
    login: {
      title: 'Anmelden',
      sign_in_btn: 'Anmelden'
    },
    bar: {
        logout: 'Abmelden',
        languages: 'Sprachen',
        settings: 'Einstellungen öffnen'
    },
    language: {
      name: 'Deutsch (CH)',
    },
    attributePage: {
        title: 'Attributänderungen',
        viewChanges: 'Änderungen anzeigen',
        dateTime: 'Datum',
        notificationType: 'Art der Benachrichtigung',
        notificationValue: 'Wert der Benachrichtig',
        oldValue: 'Alter Wert',
        newValue: 'Neuer Wert',
        accept: 'Akzeptieren',
        reject: 'Ablehnen',
    },
    Home: 'Home',
    load: 'Initialisierung läuft ...',
    Requested: "Beantragt",
    Viewed: "Angesehen",
    Executing: "Wird ausgeführt",
    Completed: "Abgeschlossen",
    Expired: "Abgelaufen",
    Cancelled: "Abgebrochen",
    Error: "Fehler",
    Rejected: "Abgelehnt",
    error: 'Es ist ein Fehler aufgetreten. Versuchen Sie es später nochmal.',
    displayname: 'Anzeigename',
    givenname: 'Name',
    surname: 'Nachname',
    email: 'E-Mail',
    mail: 'E-Mail',
    name: 'Name',
    firstname: 'Name',
    lastname: 'Nachname',
    footer_copyright: 'Alle Rechte vorbehalten.'
  };
  
  export default deCH;
  